import { addRelativePro, fetchRelativeProData, relieveRelativePro } from '@/services/config'
export default {
  namespaced: true,
  state: {
    relativeDatas: [],
    datasReady: false,
    relateCode: '',
    loading: false
  },
  mutations: {
    setRelativeDatas(state, data) {
      state.relativeDatas = data
    },
    setRelateCode(state, code) {
      state.relateCode = code
    },
    setLoad(state, isLoad) {
      state.loading = isLoad
    }
  },
  actions: {
    async addRelativePro ({ commit, dispatch }, data) {
      const chain = await addRelativePro()
      chain.params(data)
        .onSuccess(raw => {
          dispatch('fetchRelativeProData')
        })
        return chain
    },
    async fetchRelativeProData({ commit }, data) {
      commit('setLoad', true)
      const chain = await fetchRelativeProData()
      chain.params(data)
        .onSuccess(raw => {
          commit('setRelativeDatas', raw.projects)
          commit('setRelateCode', raw.relateCode)
          commit('setLoad', false)
        })
        .fetch()
        return chain
    },
    async relieveRelativePro ({ commit, dispatch }, data) {
      const chain = await relieveRelativePro()
      chain.params(data)
        .onSuccess(raw => {
          dispatch('fetchRelativeProData')
        })
        .fetch()
        return chain
    }
  }
}
